import { Loader } from './global';

const do_filter_checkbox = (maybe_input) => {
    let posttypes = [];
    let nav = maybe_input.closest('.post-types');
    let checkboxes = nav ? nav.querySelectorAll('input[type="checkbox"]:checked') : null;
    if(checkboxes){
        for(let checkbox of checkboxes){
            if(checkbox.name == "post-type-post") posttypes.push("post"); 
            if(checkbox.name == "post-type-news") posttypes.push("news-items");
        }
    }
    let wrap = nav ? nav.closest('.querywrap') : null;
    if( wrap && wrap.hasAttribute('data-posttype')) wrap.setAttribute('data-posttype', posttypes); 
    return true;
}
const do_filter_click = (li) => {
    let ul = li.tagName == 'LI' ? li.parentElement : false;
    //error with markup
    if(!ul) return false;
    if(ul.classList.contains('query-controls')){
        let vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        function theClick(theItem){
            if(theItem.hasAttribute('data-slug') && theItem.dataset.slug == '*'){
                //clicking All on active All does nothing
                if(theItem.classList.contains('active')) return false;
                for(let listitem of theItem.parentElement.children) {
                    if(listitem === theItem){
                        listitem.classList.toggle('active');
                    } else {
                        listitem.classList.remove('active');
                    }
                }
                return true;
            } else {
                theItem.classList.toggle('active');
                let all = theItem.parentElement.querySelector('[data-slug="*"]');
                if(all) all.classList.remove('active');
                return true;
            }
        } 
        
        if(vw && vw < 768){
            //mobile click  
            if(ul.classList.contains("open")){
                //do interior selectTab click
                let isClick = theClick(li);
                ul.classList.remove("open");
                return isClick;
            } else {
                ul.classList.add("open");
                return 'opened';
            }    
        } else {
            //desktop click
            let isClick = theClick(li);
            return isClick;
        }
    }
}
export const do_post_cat_pagination = (event) => {
    event.preventDefault();
    let tgt = event.target.hasAttribute('data-paged') ? event.target : event.target.closest('[data-paged]');
    //update the parent data attributes
    let paged = tgt ? tgt.dataset.paged : false;
    let parent = tgt.closest('.querywrap');
    if(parent && paged) parent.setAttribute('data-paged', paged);
    //pass the click - easy peasy
    doOnloadQuery(parent, true);
}
/* 
post types
taxonomies  - category
            - tags
tags

*/
export const do_generic_post_category = (event) => {
    event.preventDefault();
    //first toggle active 
    let this_li = (event.target.tagName == "LI") ? event.target : event.target.closest('LI');
    let good_click = this_li ? do_filter_click(this_li) : false;
    let selected = [];
    let tagselected = [];
    if(good_click === 'opened') {
        event.stopPropagation();
        return true;
    }
    if(!good_click) do_filter_checkbox(event.target);

    let wrap = this_li ? this_li.closest('.querywrap') : event.target.closest('.querywrap');
    let categorylist = wrap ? wrap.querySelector('.query-controls') : false;
    let taglist = wrap ? wrap.querySelector('.tags') : false;
    if(categorylist){
        Array.from(categorylist.children).forEach( function(li){
            if(li.classList.contains('active')) selected.push(li.dataset.slug);
        }); 
        wrap.dataset.categoriesSelected = selected;
    }  
    if(taglist){
        Array.from(taglist.children).forEach( function(li){
            if(li.classList.contains('active')) tagselected.push(li.dataset.tagId);
        });
        wrap.dataset.tagsSelected = tagselected;
    } 

    /* collect category slugs */
    let query = wrap.hasAttribute('data-query') ? wrap.dataset.query : false;
    let posttypes = wrap.hasAttribute('data-posttype') ? wrap.dataset.posttype : 'post';
    let args = wrap.hasAttribute('data-args') ? wrap.dataset.args : false;
    let nonce = window.theme_vars.nonce;
    let url = window.theme_vars.ajaxurl;
    if(nonce && url && query){
        
        url+='?action=' + query + '&nonce=' + nonce;
        let senddata = '&nonce=' + nonce;
        senddata+='&post_types=' + encodeURIComponent(posttypes);
        if(selected.length){
            //categories will be in comma separated slugs which means arrays and single both work the same
            senddata+='&categories_selected='+encodeURIComponent(selected);
        }
        if(tagselected.length){
            senddata+='&tags_selected='+encodeURIComponent(tagselected);
        }
        /* pagination */
        let perpage = wrap.hasAttribute('data-posts-per-page') ? wrap.dataset.postsPerPage : false;
        if(perpage) senddata+='&posts_per_page=' + encodeURIComponent(perpage);
        if(args) {
            //are the args in JSON
            let jsonargs = toJSON(args);
            if(jsonargs){
                senddata+='&args='+encodeURIComponent(args);
            } else {
                //otherwise try to make sense of the array
                senddata+='&args='+ new URLSearchParams(args);
            } 
        }
        let showcontrols = wrap.hasAttribute('data-show-controls') ? wrap.dataset.showControls :  false;
        if(showcontrols && showcontrols.length ) senddata+='&showcontrols='+encodeURIComponent(showcontrols);
        let showpagination = wrap.hasAttribute('data-show-pagination') ? wrap.dataset.showPagination : false;
        if(showpagination && showpagination.length) senddata+='&showpagination='+encodeURIComponent(showpagination);
        let postin = wrap.hasAttribute('data-post-in') ? wrap.dataset.postIn : false;
        if(postin && postin.length) senddata+='&postin='+encodeURIComponent(postin);
        let postlist = wrap.querySelector('div.query-post-list');
        if(postlist){
            let loader = new Loader( postlist );
            loader.doLoader();
        }
        sendit(url, senddata).then( (r)=>{ 
            let html;
            if(r.status === 200){ 
                html = r.payload;
            } else {
                html = r.message ? r.message : "Something went wrong with this request.";
            }
            wrap.innerHTML = html;
            let showtags = wrap.querySelector('.show-tags.active');
            if(showtags) {
                let activepanel = wrap.querySelector('.tag-panel');
                // Remove the transition
                let transition = activepanel.style.transition
                activepanel.style.transition = 'none';  
                activepanel.style.maxHeight = activepanel.scrollHeight + "px";
                activepanel.offsetHeight;
                // Restore the transition
                activepanel.style.transition = transition;  
            }
        });
    }
}
export const doOnloadQuery = (elem, scrollto = false) => {
  
    let query = elem.hasAttribute('data-query') ? elem.dataset.query : false;
    let posttype = elem.hasAttribute('data-posttype') ? elem.dataset.posttype : 'post';
    let args = elem.hasAttribute('data-args') ? elem.dataset.args : false;
    let categories = elem.hasAttribute('data-categories-selected') ? elem.dataset.categoriesSelected : false;
    let tags = elem.hasAttribute('data-tags-selected') ? elem.dataset.tagsSelected : false;
    let perpage = elem.hasAttribute('data-posts-per-page') ? elem.dataset.postsPerPage : false;
    let paged = elem.hasAttribute('data-paged') ? elem.dataset.paged : false;
    let nonce = window.theme_vars.nonce;
    let url = window.theme_vars.ajaxurl;

    if(nonce && url && query){
        
        url+='?action=' + query + '&nonce=' + nonce;
        let senddata = '&nonce=' + nonce;
        senddata+='&post_types=' + encodeURIComponent(posttype);
        if(categories){
            //categories will be in comma separated slugs which means arrays and single both work the same
            senddata+='&categories_selected='+ encodeURIComponent(categories);
        }

        if(args) {
            //are the args in JSON
            let jsonargs = toJSON(args);
            if(jsonargs){
                senddata+='&args='+encodeURIComponent(args);
            } else {
                //otherwise try to make sense of the array
                senddata+='&args='+ encodeURIComponent(args);
            }
            
        }
        if(perpage) senddata+='&posts_per_page=' + encodeURIComponent(perpage);
        if(paged) senddata+='&paged=' + encodeURIComponent(paged);
        if(tags) senddata+='&tags_selected=' + encodeURIComponent(tags);
        let showcontrols = elem.hasAttribute('data-show-controls') ? elem.dataset.showControls :  false;
        if(showcontrols && showcontrols.length ) senddata+='&showcontrols='+encodeURIComponent(showcontrols);
        let showpagination = elem.hasAttribute('data-show-pagination') ? elem.dataset.showPagination : false;
        if(showpagination && showpagination.length) senddata+='&showpagination='+encodeURIComponent(showpagination);
        let postin = elem.hasAttribute('data-post-in') ? elem.dataset.postIn : false;
        if(postin && postin.length) senddata+='&postin='+encodeURIComponent(postin);

        let postlist = elem.querySelector('div.query-post-list');
        if(postlist){
            let loader = new Loader( postlist );
            loader.doLoader();
        }
        sendit(url, senddata).then( (r)=>{
   
            var wrap = elem.closest('.querywrap');
            let html;
            if(r.status === 200){ 
                html = r.payload;
            } else {
                html = r.message ? r.message : "Something went wrong with this request.";
            }
            wrap.innerHTML = html;
            if(scrollto){
                var box = elem.getBoundingClientRect();
                var body = document.body;
                var docEl = document.documentElement;
                var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
                var clientTop = docEl.clientTop || body.clientTop || 0;
                var top  = box.top +  scrollTop - clientTop;
                window.scrollTo({
                    top: top,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            //Greenheart-specific Q nonsense

            
        });
    }

}

function toJSON(str){ 
    try {
        var obj = JSON.parse(str);
        if (obj && typeof obj === "object") {
            return obj;
        }
    } 
    catch (e) {
        console.log(e)
        return false;
    }
}